import React, { useMemo } from "react";
import ReactFlow, { Controls, MiniMap, Panel, Node, Edge } from "reactflow";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import {
    useGraph,
    useSetGraphCenterToRootNodeProps,
    useGraphActions,
} from "../../hooks";
import { DEFAULT_EDGE_OPTIONS } from "../../constants/settings";
import DownloadButton from "../downloadButton/DownloadButton";
import "reactflow/dist/style.css";
import "./Graph.css";

export interface GraphProps {
    initialNodes: Node[];
    initialEdges: Edge[];
    onSetTriggerNameFilter: (triggerName: string) => void;
}

const Graph = ({
    initialEdges,
    initialNodes,
    onSetTriggerNameFilter,
}: GraphProps) => {
    const { t } = useTranslation();
    const {
        nodeTypes,
        edgeTypes,
        nodes,
        edges,
        onNodesChange,
        onEdgesChange,
        connect,
        alignAndFitNodes,
    } = useGraph({ initialEdges, initialNodes });

    const { moveToNode } = useSetGraphCenterToRootNodeProps();

    const { edgeClick, nodeClick } = useGraphActions({
        nodes,
        edges,
        moveToNode,
        setTriggerNameFilter: onSetTriggerNameFilter,
    });

    return (
        <ReactFlow
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            nodes={useMemo(() => nodes, [nodes])}
            edges={useMemo(() => edges, [edges])}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={connect}
            onEdgeClick={edgeClick}
            onNodeClick={nodeClick}
            fitView
            nodesConnectable={false}
            defaultEdgeOptions={DEFAULT_EDGE_OPTIONS}
        >
            <Controls />
            <MiniMap
                position="top-right"
                nodeStrokeWidth={3}
                zoomable
                pannable
            />
            <Panel className="nlp-buttons-panel" position="top-left">
                <Button onClick={() => alignAndFitNodes()}>
                    {t("nlp.designerAlignNodesButton")}
                </Button>
                <DownloadButton />
            </Panel>
        </ReactFlow>
    );
};

export default Graph;
